import { ServiceApplication_Key } from "../../../../config/helpers";
import { IFilterMarque } from "../../../../models/interfaces/IFilterMarque";
import { IFilterSociete } from "../../../../models/interfaces/IFilterSociete";
import { ISocieteActeursJuridiquesReturn, ISocieteCompteReturn, ISocieteDetailsReturn, ISocieteMarquesReturn, ISocietesReturn } from "../../../../models/interfaces/ISociete";
import { IFormOrganisation } from "../../../../models/interfaces/IFormOrganisation";
import { ISocieteSirenReturn } from "../../../../models/interfaces/ISocieteSiretReturn";

import { apiSlice } from "../../api";

export interface societeApiQueryBody {
    Application_Key: string;
    // eslint-disable-next-line
    Values: any;
}

export interface ISocieteGetDataFromSiret {
    Siret: string;
    IdDemande?: number | null;
    IdSociete?: number | null;
}

export const societeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchSocietes: builder.query<ISocietesReturn, IFilterSociete|undefined>({
      query: (obj) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: obj,
        };

        return {
          url: "/Societe/Societe_Search",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchSociete: builder.query<ISocieteDetailsReturn, string>({
      query: (IdSociete: string) => {
        const body: societeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {
            IdSociete: IdSociete,
          },
        };
        return {
          url: "/Societe/Societe_Get",
          method: "POST",
          body: body,
        };
      }
    }),
 
  fetchSocieteCompte: builder.query<ISocieteCompteReturn, null>({
    query: () => {
      const body: societeApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: {
        },
      };
      return {
        url: "/Societe/Societe_Compte_Get",
        method: "POST",
        body: body,
      };
    },
  }),

  fetchSocieteGetMarques: builder.query<ISocieteMarquesReturn, null>({
    query: () => {
      const body: societeApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: {},
      };
      return {
        url: "/Societe/Societe_GetMarques",
        method: "POST",
        body: body,
      };
    },
  }),

  fetchSocieteGetActeursJuridiques: builder.query<ISocieteActeursJuridiquesReturn, null>({
    query: () => {
      const body: societeApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: {},
      };
      return {
        url: "/Societe/Societe_GetActeursJuridiques",
        method: "POST",
        body: body,
      };
    },
  }),


  fetchSocieteGetAllMarques: builder.query<ISocieteMarquesReturn, null>({
    query: () => {
      const body: societeApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: {},
      };
     return {
        url: "/Societe/Societe_GetAllMarques",
        method: "POST",
        body: body,
      };
    },
  }),
  fetchSocietesByIds: builder.query<ISocietesReturn, IFilterMarque|undefined>({
    query: (obj) => {
      const body: societeApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: obj,
      };

      return {
        url: "/Societe/SocietesByIds_Search",
        method: "POST",
        body: body,
      };
    },
  }),
  SocieteCompteUpdate: builder.mutation<ISocieteCompteReturn, IFormOrganisation>({
    query: (data) => {
      const body: societeApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: data,
      };
      return {
        url: "/Societe/Societe_Compte_Update",
        method: "POST",
        body: body,
      };
    },
  }),
  fetchSocieteFromSiret: builder.query<ISocieteSirenReturn, ISocieteGetDataFromSiret>({
      query: (data: ISocieteGetDataFromSiret) => {
        const body: societeApiQueryBody = {
          Values: {
            Siret: data.Siret,
            IdDemande: data.IdDemande ?? null,
            IdSociete: data.IdSociete ?? null
          },
          Application_Key: ServiceApplication_Key,
        };
        return {
          url: "/Societe/Societe_GetFromSiret",
          method: "POST",
          body: body,
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  //FetchCountUtilisateursQuery,
  useFetchSocietesQuery,
  useFetchSocieteQuery,
  useFetchSocieteCompteQuery,
  useFetchSocieteGetMarquesQuery,
  useFetchSocieteGetActeursJuridiquesQuery,
  useFetchSocieteGetAllMarquesQuery,
  useFetchSocietesByIdsQuery,
  useSocieteCompteUpdateMutation,
  useFetchSocieteFromSiretQuery,
  useLazyFetchSocieteFromSiretQuery,
} = societeApi;
